import React, { JSX } from 'react'

interface ConditionalRenderingProps {
  shouldRender: boolean;
  children: JSX.Element | JSX.Element[];
}

const ConditionalRendering: React.FC<ConditionalRenderingProps> = ({shouldRender, children}) => {
  if (!shouldRender) return <></>
  return children
}

export default ConditionalRendering
